<mat-sidenav-container fullscreen [ngClass]="{ 'dark-mode': darkMode }">
  <mat-sidenav mode="push" #sideMenu>
    <mat-nav-list (click)="sideMenu.close()">
      <a mat-list-item [routerLink]="['how-to']">
        <mat-icon class="mr-3">auto_stories</mat-icon>
        <span>Guida all'utilizzo della Dashboard</span>
      </a>

      <a mat-list-item *ngIf="isSuperAdmin$ | async" [routerLink]="['roles']">
        <mat-icon class="mr-3">security</mat-icon>
        <span>Ruoli</span>
      </a>

      <a mat-list-item hidden *ngIf="isSuperAdmin$ | async" [routerLink]="['permissions']">
        <mat-icon class="mr-3">lock</mat-icon>
        <span>Permessi</span>
      </a>

      <a mat-list-item *ngIf="isSuperAdmin$ | async" [routerLink]="['users']">
        <mat-icon class="mr-3">manage_accounts</mat-icon>
        <span>Utenti</span>
      </a>

      <a mat-list-item *ngIf="enableEvents$ | async" [routerLink]="['events']">
        <mat-icon class="mr-3">pending_actions</mat-icon>
        <span>Eventi</span>
      </a>

      <a mat-list-item [routerLink]="['/private-area', 'users', user.id_utente, 'edit-password']">
        <mat-icon class="mr-3">vpn_key</mat-icon>
        <span>Modifica la mia password</span>
      </a>

      <a mat-list-item *ngIf="enableForcePassword$ | async" [routerLink]="['force-password']">
        <mat-icon class="mr-3">password</mat-icon>
        <span>Forza aggiornamento password</span>
      </a>

      <a mat-list-item *ngIf="enableUserAddition$ | async" [routerLink]="['user-addition']">
        <mat-icon class="mr-3">person_add</mat-icon>
        <span>Associazione massiva utenti</span>
      </a>

      <a mat-list-item *ngIf="enableUserCancellation$ | async" [routerLink]="['user-cancellation']">
        <mat-icon class="mr-3">person_remove</mat-icon>
        <span>Cancellazione massiva utenti bloccati</span>
      </a>

      <a mat-list-item *ngIf="enableInactiveUserCancellation$ | async" [routerLink]="['inactive-users']">
        <mat-icon class="mr-3">person_add_disabled</mat-icon>
        <span>Cancellazione utenti inattivi</span>
      </a>

      <a mat-list-item *ngIf="enableUserDuplicated$ | async" [routerLink]="['duplicate-registration']">
        <mat-icon class="mr-3">people_alt</mat-icon>
        <span>Tentativi di registrazione su CF/PIVA già registrato</span>
      </a>

      <a mat-list-item *ngIf="enableReviews$ | async" [routerLink]="['reviews']">
        <mat-icon class="mr-3">star</mat-icon>
        <span>Recensioni</span>
      </a>

      <a mat-list-item *ngIf="enableExactAssociation$ | async" [routerLink]="['association-contract']">
        <mat-icon class="mr-3">assignment_ind</mat-icon>
        <span>Associazione puntuale</span>
      </a>

      <a mat-list-item *ngIf="enableSearchIrenYou$ | async" [routerLink]="['search-customers']">
        <mat-icon class="mr-3">person_search</mat-icon>
        <span>Ricerca Utente IrenYou</span>
      </a>

      <a mat-list-item *ngIf="userExtraction$ | async" [routerLink]="['user-extraction']">
        <mat-icon class="mr-3">folder_shared</mat-icon>
        <span>Estrazione utenti registrati</span>
      </a>

      <a mat-list-item *ngIf="enableSearchAssociation$ | async" [routerLink]="['search-association']">
        <mat-icon class="mr-3">search</mat-icon>
        <span>Ricerca Associazioni IrenYou</span>
      </a>

      <a mat-list-item *ngIf="enablePrivacyTc$ | async" [routerLink]="['informativa-privacy']">
        <mat-icon class="mr-3">description</mat-icon>
        <span>Informativa Privacy e condizioni di utilizzo</span>
      </a>

      <a mat-list-item *ngIf="enableAgingFatture$ | async" [routerLink]="['aging-fatture']">
        <mat-icon class="mr-3">pending_actions</mat-icon>
        <span>Aging fatture</span>
      </a>

      <a mat-list-item *ngIf="enableRicercaUtentiFb$ | async" [routerLink]="['ricerca-utenti-fb']">
        <mat-icon class="mr-3">pending_actions</mat-icon>
        <span>Ricerca utenti Facebook</span>
      </a>

      <a mat-list-item (click)="logout()">
        <mat-icon class="mr-3">exit_to_app</mat-icon>
        <span>Logout</span>
      </a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar class="iren-dashboard-header bg-transparent mat-elevation-z2 pb-1">
      <button class="menu-button" mat-icon-button (click)="sideMenu.open('mouse')">
        <mat-icon class="mr-3">menu</mat-icon>
      </button>

      <img [routerLink]="['/private-area']" class="iren-logo mx-5" src="content/assets/images/svg/LOGO_IREN_LGS.svg" matTooltip="Home" />

      <button mat-icon-button [matTooltip]="'Hai effettuato l\'accesso con l\'utente: ' + user.email" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
        <mat-icon class="mr-3">account_circle</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="logout()">
          <mat-icon matTooltip="Logout">exit_to_app</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
    </mat-toolbar>

    <router-outlet></router-outlet>
    <div class="text-center my-5" *ngIf="!environment.production">
      <mat-slide-toggle [checked]="darkMode" (toggleChange)="setDarkMode()" class="text-center"></mat-slide-toggle>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
